module.exports = __webpack_public_path__ + "static/Gotham-Book-92c3bbd48b2b8ffb9fa1c9d0529afa75.ttf";